import { RelationshipRoleCompatibilityOptionsType } from './types';

export const RELATIONSHIP_ROLE_COMPATIBILITY_OPTIONS: RelationshipRoleCompatibilityOptionsType =
  [
    { id: 'leader', title: '🖐️ Leader' },
    { id: 'equal', title: '💕 Equal' },
    { id: 'follower', title: '👀 Follower' },
  ];
